<template>
  <transition name="widgetbutton">
    <slot />
  </transition>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
/* AVATAR TRANSITION */
.kw-avatar-transition-enter-from {
  opacity: 0;
  transform: scale(0.15);
  background-color: transparent;

  // transform: scale(3) translateY(-19px);
  .avatar-wrapper {
    border-width: 0;
    border-radius: 50%;
  }
}

.kw-avatar-transition-enter-active {
  transition: opacity 0.4s linear 0.1s,
    transform 0.5s cubic-bezier(0.1, 0.5, 0.3, 1.5) 0.1s, background-color 0.15s;

  // transform .5s ease-in-out .2s;
  .avatar-wrapper {
    transition: border-width 0.25s linear;
  }
}

.kw-avatar-transition-enter-to,
.kw-avatar-transition-leave-from {
  opacity: 1;
  transform: scale(1);
  background-color: #ffffff;
}

.kw-avatar-transition-leave-to {
  opacity: 0;
  // interfiers with the Avatar Transition. Not sure yet to work around that issue.
  //transform: scale(.15);
  background-color: transparent;
}

.kw-avatar-transition-leave-active {
  transition: opacity 0.4s linear 0.1s,
    transform 0.5s cubic-bezier(0.1, 0.5, 0.3, 1.5) 0.1s, background-color 0.15s;
}
</style>
